import "./scss/index.scss";
import YuduLogo from "../../../assets/Yudu-logo.png";
import { Box, LinearProgress, Stack } from "@mui/material";
import { useHostBranding } from "../../../hooks/useHostBranding";

const LoadingPage = () => {
  // Hostname-resolved tenant logo (pre-auth); neutral Yudu when unbranded.
  const { logoUrl, orgName } = useHostBranding();
  return (
    <Box className="loading-page" sx={{ zIndex: 2147483647, backgroundColor: theme => theme.palette.background.default }}>
      <Stack spacing={2}>
        <img src={logoUrl ?? YuduLogo} alt={orgName ?? "Yudu"} style={{ maxHeight: 50, maxWidth: 200, width: "auto", height: "auto" }} />
        <LinearProgress variant="indeterminate" color="inherit"/>
      </Stack>
    </Box>
  );
};

export default LoadingPage;
